// src/LoginForm.jsx
// Muster: CRM LoginForm.jsx - eigene Route "/login" statt Modal (so gewuenscht).
// Angepasst: Ziel nach erfolgreichem Login ist "/extraction" statt "/tasks".
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from './authContext';

import api from './api';

const LoginForm = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const response = await api.post("/auth/login", {
        username,
        password,
      });
      login(response.data.token);
      navigate("/extraction");
    } catch (err) {
      if (err.response) {
        setError(err.response.data.message || "Login fehlgeschlagen. Bitte überprüfe deine Angaben.");
      } else {
        setError("Netzwerkfehler. Bitte versuche es später erneut.");
      }
    }
  };

  return (
    <div style={{ maxWidth: "400px", margin: "0 auto", padding: "20px" }}>
      <h2>Anmeldung</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "15px" }}>
          <label htmlFor="username">Benutzername:</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            style={{ width: "100%", padding: "8px" }}
          />
        </div>
        <div style={{ marginBottom: "15px" }}>
          <label htmlFor="password">Passwort:</label>
          <div style={{ position: "relative" }}>
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{ width: "100%", padding: "8px" }}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "#6c757d",
              }}
            >
              {showPassword ? "👁️" : "🔒"}
            </button>
          </div>
        </div>
        <button
          type="submit"
          style={{
            width: "100%",
            padding: "10px",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Anmelden
        </button>
      </form>
    </div>
  );
};

export default LoginForm;
